import axios from "../axios";
import api from "../api";

export const state = {
  prompts: {
    prompt1: {},
    prompt2: {},
    prompt3: {},
    prompt4: {},
    prompt5: {},
  },
}

export const mutations = {
  SET_WIN_BACK_PROMPTS_V2 (state, value) {
    state.prompts = value;
  },
  UPDATE_WIN_BACK_PROMPT_V2 (state, {step, value}) {
    state.prompts[step] = value
  }
}
export const actions = {
  async get_win_back_prompts_v2 ({commit}) {
    try {
      commit('SET_REQ_STATUS', 'loading')
      const { data } = await axios.get(`${api.personalized_emails.settings}/prompts-win-back-didnt-take-2-months`);
      commit('SET_WIN_BACK_PROMPTS_V2', data);
      commit('SET_REQ_STATUS', 'idle')
    } catch (err) {
      commit('SET_REQ_STATUS', 'failed')
      console.log(err)
    }
  },
  async save_win_back_prompts_v2 ({state, commit}, key) {
    try {
      commit('SET_REQ_STATUS', `saving-${key}`)
      await axios.put(`${api.personalized_emails.settings}/prompts-win-back-didnt-take-2-months`, {[key]: state.prompts[key]});
      commit('SET_REQ_STATUS', 'idle')
    } catch (err) {
      commit('SET_REQ_STATUS', 'failed')
      console.log(err)
    }
  }
}